import React from 'react';
const rows = [{
  before: 'Ganze Nächte mit der Suche nach Drills auf YouTube oder Instagram verbringen.',
  after: 'Fertige Trainingseinheiten in 2 Klicks auf deinem Tablet.'
}, {
  before: 'Stress vor der Halle, weil du nicht weißt, was du heute anbieten sollst.',
  after: 'Absolute Sicherheit und Souveränität vor der Mannschaft.'
}, {
  before: 'Wirre Erklärungen, die die Spieler nicht verstehen.',
  after: 'Glasklare Schemata und professionelle Grafiken.'
}, {
  before: 'Repetitives Training und eine demotivierte Mannschaft.',
  after: 'Konstanter und stimulierender technischer Fortschritt.'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        {/* Time cost callout */}
        <div className="bg-badge-red/10 border border-badge-red/20 rounded-2xl p-6 sm:p-8 mb-12 text-center" data-id="element-58">
          <p className="text-text-main text-lg sm:text-2xl font-bold leading-relaxed" data-id="element-59">
            Jedes Training manuell zu entwerfen, kostet dich im Durchschnitt{' '}
            <span className="text-badge-red font-black" data-id="element-60">
              3 bis 5 Stunden pro Woche
            </span>
            . Das sind{' '}
            <span className="text-badge-red font-black" data-id="element-61">
              mehr als 150 Stunden pro Jahr, die du für immer zwischen Zetteln
              und Skizzen verlierst.
            </span>
          </p>
        </div>

        <div className="bg-bg-alt rounded-2xl shadow-2xl border border-border-light overflow-hidden" data-id="element-62">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-white/5" data-id="element-63">
            <div className="px-6 py-5 font-bold text-red-400 text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-64">
              OHNE HANDBALL-FIX (Deine Kosten heute)
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm" data-id="element-65">
              MIT HANDBALL-FIX (Dein Leben morgen)
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-66">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-white/[0.02] transition-colors" data-id="element-67">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-black/20" data-id="element-68">
                  <div className="w-6 h-6 rounded-full bg-badge-red/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-69">
                    <span className="text-badge-red font-bold text-sm" data-id="element-70">✕</span>
                  </div>
                  <p className="text-text-sec font-medium" data-id="element-71">{row.before}</p>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-72">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-73"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 relative z-10" data-id="element-74">
                    <span className="text-check-green font-bold text-sm" data-id="element-75">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main font-bold relative z-10" data-id="element-76">
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}